import { useNavigate  } from 'react-router-dom';
import juegos from '../assets/juegos.json';

export default function LateralJuegos({ }: {}) {

  const navigate = useNavigate();

  function ClickGooglePlay(){
    window.open("https://play.google.com/store/apps/details?id=newspaper.games&listing=deia", "_blank");
  }

  function ClickAppStore(){
    window.open("https://apps.apple.com/us/app/everyday-train-your-brain/id6745964306?ppid=3bad5dd4-0340-4986-a20f-b5594a3fa952", "_blank");
  }

  function ClickJuego(juego: string){
    CerrarLateral();
    navigate("/"+juego+"/0");
  }

  function CerrarLateral(){
    document.getElementById("lateral-juegos")!.style.left = "-19rem";
    document.getElementById("lateral-juegos")!.style.boxShadow = "none";
    document.getElementById("lateral-overlay")!.style.opacity = "0";
    document.getElementById("lateral-overlay")!.style.pointerEvents = "none";
  }

  function Home(){
    CerrarLateral();
    navigate("/");
  }

  function GoDeia(){
    window.open("https://www.deia.eus/","_self");
  }

  return (
    <>
    <div className="lateral-overlay" id="lateral-overlay" onClick={()=>CerrarLateral()}></div>
    <div className="lateral-juegos" id='lateral-juegos'>

      <button className="lateral-juegos__cerrar" onClick={()=>CerrarLateral()}>✕</button>

      <nav className="lateral-juegos__nav">
        <h3 className="lateral-juegos__seccion">Juegos</h3>

        <div className="lateral-juegos__item" onClick={() => Home()}>
          <div className="lateral-juegos__icono-wrap lateral-juegos__icono-wrap--home">
            <img className="lateral-juegos__icono lateral-juegos__icono--home" src="./iconos/home.png" />
          </div>
          <span className="lateral-juegos__nombre">Inicio</span>
          <span className="lateral-juegos__flecha">›</span>
        </div>

        {juegos.map((juego, i) => (
          <div className="lateral-juegos__item" key={juego.id} onClick={() => ClickJuego(juego.escena)}>
            <div className="lateral-juegos__icono-wrap" style={{ background: juego.color }}>
              <img className="lateral-juegos__icono" src={"./" + juego.icono} />
            </div>
            <span className="lateral-juegos__nombre">{juego.nombre}</span>
            <span className="lateral-juegos__flecha">›</span>
          </div>
        ))}

        <h3 className="lateral-juegos__seccion">Noticias</h3>

        <div className="lateral-juegos__item" onClick={() => GoDeia()}>
          <img className="lateral-juegos__logo-deia" src="./logo-deia.png" />
          <span className="lateral-juegos__flecha">›</span>
        </div>
      </nav>

    </div>
    </>
  )
}
